(function ($) {
  Drupal.behaviors.slideDropdown = {
    attach: function (context) {
      var drop = $('.js-homepage-slide__dropdown');

      $(drop, context).hide();

      $('.js-homepage-slide__main', context).on('click', function (e) {
        e.stopPropagation();
        $(window).trigger('resize');
        drop.show();
      });

      $('.homepage-slide__nav .slick-prev, .homepage-slide__nav .slick-next', context).on('click', function (e) {
        e.stopPropagation();
        drop.hide();
      });

      $('.js-close', context).on('click', function (e) {
        e.stopPropagation();
        drop.hide();
      });
    }
  };
})(jQuery);
